"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AllergyStatusSchema () {
        return AllergyStatusSchema;
    },
    get PATIENT_ALLERGIES_CONFLICT () {
        return PATIENT_ALLERGIES_CONFLICT;
    }
});
const _zod = require("zod");
const AllergyStatusSchema = _zod.z.enum([
    'unknown',
    'nka',
    'has_allergies'
]);
const PATIENT_ALLERGIES_CONFLICT = 'PATIENT_ALLERGIES_CONFLICT';
